export default __webpack_public_path__ + "static/media/amazonintegration.df15089f.svg";